import { defineMessages } from 'react-intl-next';

export default defineMessages({
	goBackLabel: {
		id: 'rovo-chat.view-agent.go-back-label',
		defaultMessage: 'Go back',
		description: 'Label for go back button',
	},
	modalTitle: {
		id: 'rovo-chat.view-agent.modal-title',
		defaultMessage: 'Browse Agents',
		description: 'Title of the modal to view agent',
	},
	closeButton: {
		id: 'rovo-chat.view-agent.close-button',
		defaultMessage: 'Close',
		description: 'Button to close the view agent modal',
	},
	createdByLabel: {
		id: 'rovo-chat.view-agent.created-by-label',
		defaultMessage: `<text>by</text> {agentName}`,
		description: 'Label to indicate the creator of the agent',
	},
	chatToAgentButton: {
		id: 'rovo-chat.view-agent.chat-to-agent-button',
		defaultMessage: 'Chat to agent',
		description: 'Button to chat to agent',
	},
	instructionsLabel: {
		id: 'rovo-chat.view-agent.instructions-label',
		defaultMessage: 'Instructions',
		description: 'Label for instructions',
	},
	copyInstructionsLabel: {
		id: 'rovo-chat.view-agent.copy-instructions-label',
		defaultMessage: 'Copy',
		description: 'Label for copy instructions button',
	},
	openChatLabel: {
		id: 'rovo-chat.view-agent.open-chat-label',
		defaultMessage: 'Open chat',
		description: 'Label for open chat',
	},
	knowledgeLabel: {
		id: 'rovo-chat.view-agent.knowledge-label',
		defaultMessage: 'Knowledge',
		description: 'Label for knowledge',
	},
	usersMetadataLabel: {
		id: 'rovo-chat.view-agent.users-metadata-label',
		defaultMessage: '# of users',
		description: 'Users metadata label',
	},
	reactionsMetadataLabel: {
		id: 'rovo-chat.view-agent.reactions-metadata-label',
		defaultMessage: '# of reactions',
		description: 'Reactions metadata label',
	},
	favouritesMetadataLabel: {
		id: 'rovo-chat.view-agent.favourites-metadata-label',
		defaultMessage: '# of favourites',
		description: 'Favourites metadata label',
	},
	duplicateAgent: {
		id: 'rovo-chat.view-agent.duplicate-agent',
		defaultMessage: 'Duplicate agent',
		description: 'Button to duplicate an agent',
	},
	editAgent: {
		id: 'rovo-chat.view-agent.edit-agent',
		defaultMessage: 'Edit agent',
		description: 'Button to edit an agent',
	},
	deleteAgent: {
		id: 'rovo-chat.view-agent.delete-agent',
		defaultMessage: 'Delete agent',
		description: 'Button to delete an agent',
	},
	copyLinkToProfile: {
		id: 'rovo-chat.view-agent.copy-link-to-profile',
		defaultMessage: 'Copy link',
		description: 'Button to copy the link to the agent profile',
	},
	linkedCopiedToProfile: {
		id: 'rovo-chat.view-agent.link-copied-to-profile',
		defaultMessage: 'Copied URL',
		description: 'Button confirming link to agent profile is copied',
	},
	moreActionsLabel: {
		id: 'rovo-chat.view-agent.more-actions-label',
		defaultMessage: 'More actions',
		description: 'More actions dropdown menu label',
	},
});
